import { EventsName } from "../../shared/enums/eventsName";

/**
 * Maps document type to the corresponding event name for BigQuery logging
 * @param docType - The document type string
 * @returns The corresponding event name from EventsName enum, or undefined if no match found
 */
export const getDeleteDocumentEventName = (
  docType: string,
): string | undefined => {
  const docTypeToEventMap: Record<string, string> = {
    nar_letter: EventsName.NAR_LETTER_DELETED,
    approval_letter: EventsName.APPROVAL_LETTER_DELETED,
    filled_form: EventsName.FILLED_FORM_DELETED,
    denial_letter: EventsName.DENIAL_LETTER_DELETED,
  };

  return docTypeToEventMap[docType];
};

/**
 * Maps document type to the corresponding event name for BigQuery logging
 * Falls back to NAR_LETTER_DELETED if no specific event is found
 * @param docType - The document type string
 * @returns The corresponding event name from EventsName enum
 */
export const getDeleteDocumentEventNameWithFallback = (
  docType: string,
): string => {
  return getDeleteDocumentEventName(docType) || EventsName.NAR_LETTER_DELETED;
};
